goog.provide('el8.ptdata.model.note.visit');

goog.require('el8.ptdata.model.amendmentRequest');
goog.require('el8.ptdata.model.note.visitBulletSet');
goog.require('el8.ptdata.model.note.visitAlertSet');
goog.require('el8.ptdata.model.note.muInfo');
goog.require('el8.ptdata.model.note.bill');
goog.require('el8.ptdata.model.note.checklistSet');
goog.require('el8.ptdata.model.note.vitalsSet');

goog.require('el8.appservice.notifier');
goog.require('el8.data.visitNoteFormTemplates');
goog.require('el8.data.visitNoteTypes');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.note.base');
goog.require('el8.ptdata.model.note.checkout');
goog.require('el8.ptdata.model.note.visitNoteEdit');
goog.require('el8.service.tz');
goog.require('el8.template.ptdata.model.note');


// --------------
// * VISIT NOTE *
// --------------
(function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8.ptdata.model.note.base);

    _class.prototype.populate = function(spec) {

        spec = spec || {};
        if (spec.type) {
            spec.noteTypeId = spec.type.id;
            el8.data.visitNoteTypes.create(spec.type);
        }
        if (!spec.patientAge) {
            spec.patientAge = el8.ptdata.currPatient.getAge();
        }
        if (!spec.displayPatientAge) {
            spec.displayPatientAge = el8.ptdata.currPatient.getDisplayAge();
        }
        spec.custom_observations = spec.custom_observations || [];

        if (spec.signatures) {
          // note that signedAt timestamps in this collection are strings
          spec.signatures = el8.util.keysFromUnderscoreToCamel(spec.signatures);
        }

        this.parent.populate.call(this, spec);

        this.setEdits(spec['edits'].map(el8.ptdata.model.note.visitNoteEdit));

        var noteId = this.getId();

        this.setChecklistSets({
            'pe': el8.ptdata.model.note.checklistSet(noteId, spec['checklists']['pe']),
            'ros': el8.ptdata.model.note.checklistSet(noteId, spec['checklists']['ros'])
        });

        var vitalSpecs = {
            'bp': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.bp, spec['bps']),
            'rr': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.rr, spec['rrs']),
            'hr': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.hr, spec['hrs']),
            'height': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.height, spec['heights']),
            'weight': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.weight, spec['weights']),
            'pain': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.pain, spec['pains']),
            'temperature': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.temperature, spec['temperatures']),
            'oxygen': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.oxygen, spec['oxygens']),
            'hc': el8.ptdata.model.note.vitalsSet(noteId,
                    el8.ptdata.model.note.hc, spec['hcs'])
        };
        if (el8.data.practiceSettings.isAdditionalVitalsEnabled()) {
            el8.util.consts.ADDITIONAL_VITALS.forEach(function(customObservation) {
                var vitalData = _.filter(spec['custom_observations'], function(v) {
                    return v.name === customObservation;
                });
                vitalSpecs[customObservation] = el8.ptdata.model.note.vitalsSet(
                                            noteId,
                                            el8.ptdata.model.note.customObservation,
                                            vitalData || [],
                                            customObservation
                                          );
            });
        }

        this.setVitalsSets(vitalSpecs);

        this.setBulletSets({
            'Problem':
                el8.ptdata.model.note.visitBulletSet({category: 'Problem', noteId: this.getId()}, spec['problem_bullets']),
            'Narrative':
                el8.ptdata.model.note.visitBulletSet({category: 'Narrative', noteId: this.getId()}, spec['narrative_bullets']),
            'Followup':
                el8.ptdata.model.note.visitBulletSet({category: 'Followup', noteId: this.getId()}, spec['followup_bullets']),
            'Reason':
                el8.ptdata.model.note.visitBulletSet({category: 'Reason', noteId: this.getId()}, spec['reason_bullets']),
            'Past':
                el8.ptdata.model.note.visitBulletSet({category: 'Past', noteId: this.getId()}, spec['past_bullets']),
            'Surgical':
                el8.ptdata.model.note.visitBulletSet({category: 'Surgical', noteId: this.getId()}, spec['surgical_bullets']),
            'Family':
                el8.ptdata.model.note.visitBulletSet({category: 'Family', noteId: this.getId()}, spec['family_bullets']),
            'Social':
                el8.ptdata.model.note.visitBulletSet({category: 'Social', noteId: this.getId()}, spec['social_bullets']),
            'Instr':
                el8.ptdata.model.note.visitBulletSet({category: 'Instr', noteId: this.getId()}, spec['instr_bullets']),
            'Pe':
                el8.ptdata.model.note.visitBulletSet({category: 'Pe', noteId: this.getId()}, spec['pe_bullets']),
            'Ros':
                el8.ptdata.model.note.visitBulletSet({category: 'Ros', noteId: this.getId()}, spec['ros_bullets']),
            'Med':
                el8.ptdata.model.note.visitBulletSet({category: 'Med', noteId: this.getId()}, spec['med_bullets']),
            'Objective':
                el8.ptdata.model.note.visitBulletSet({category: 'Objective', noteId: this.getId()}, spec['objective_bullets']),
            'Data':
                el8.ptdata.model.note.visitBulletSet({category: 'Data', noteId: this.getId()}, spec['data_bullets']),
            'Assessment':
                el8.ptdata.model.note.visitBulletSet({category: 'Assessment', noteId: this.getId()}, spec['assessment_bullets']),
            'Plan':
                el8.ptdata.model.note.visitBulletSet({category: 'Plan', noteId: this.getId()}, spec['plan_bullets']),
            'Test':
                el8.ptdata.model.note.visitBulletSet({category: 'Test', noteId: this.getId()}, spec['test_bullets']),
            'Tx':
                el8.ptdata.model.note.visitBulletSet({category: 'Tx', noteId: this.getId()}, spec['tx_bullets']),
            'Hpi':
                el8.ptdata.model.note.visitBulletSet({category: 'Hpi', noteId: this.getId()}, spec['hpi_bullets']),
            'Allergies':
                el8.ptdata.model.note.visitBulletSet({category: 'Allergies', noteId: this.getId()}, spec['allergies_bullets']),
            'Habits':
                el8.ptdata.model.note.visitBulletSet({category: 'Habits', noteId: this.getId()}, spec['habits_bullets']),
            'Assessplan':
                el8.ptdata.model.note.visitBulletSet({category: 'Assessplan', noteId: this.getId()}, spec['assessplan_bullets']),
            'Dateprocedure':
                el8.ptdata.model.note.visitBulletSet({category: 'Dateprocedure', noteId: this.getId()}, spec['dateprocedure_bullets']),
            'Consultant':
                el8.ptdata.model.note.visitBulletSet({category: 'Consultant', noteId: this.getId()}, spec['consultant_bullets']),
            'Attending':
                el8.ptdata.model.note.visitBulletSet({category: 'Attending', noteId: this.getId()}, spec['attending_bullets']),
            'Referenced':
                el8.ptdata.model.note.visitBulletSet({category: 'Referenced', noteId: this.getId()}, spec['referenced_bullets']),
            'Orders':
                el8.ptdata.model.note.visitBulletSet({category: 'Orders', noteId: this.getId()}, spec['orders_bullets']),
            'Procedure':
                el8.ptdata.model.note.visitBulletSet({category: 'Procedure', noteId: this.getId()}, spec['procedure_bullets'])
        });

        var alertSet = el8.ptdata.model.note.visitAlertSet(spec.alerts || []);
        this.setAlerts(alertSet);
    };

    _class.addProperty("timeWithPatient", true);  // not string; needs to be null-able
    _class.addProperty("timeDocumenting", true);  // not string; needs to be null-able

    _class.addIntProperty("appointmentId", true);
    _class.addDateTime("apptTime", true);
     // date from documentDate and time from apptTime if avail., or time form documentDate otherwise
    _class.addDateTime("displayDate", true);
    _class.addStringProperty("bmi", true);
    _class.addIntProperty("patientAge", true);
    _class.addStringProperty("displayPatientAge");
    _class.addProperty("rxIds");

    _class.addProperty("signatures", true);

    _class.addBoolean('preview');
    _class.addModelProperty("checkout", el8.ptdata.model.note.checkout, true);

    _class.addModelProperty("bill", el8.ptdata.model.note.bill, true);
    _class.addModelProperty("meaningfulUseInfo", el8.ptdata.model.note.muInfo, true);
    _class.addModelProperty("amendmentRequest", el8.ptdata.model.amendmentRequest, true);

    _class.addProperty("checklistSets");
    _class.addProperty("vitalsSets");
    _class.addStringProperty("previousWeight");
    _class.addStringProperty("weightDelta");
    _class.addStringProperty("previousBmi");
    _class.addStringProperty("bmiDelta");
    _class.addDateTime("previousTime");

    _class.addProperty("bulletSets");
    _class.addProperty("edits");
    _class.addProperty("alerts");

    _class.addStringProperty("template", true);
    _class.addStringProperty("templateClass");

    _class.addIntProperty("physicianId", true);


    _class.prototype.getThumbnails = function() {
        return this.getImages().map(function(url) {
            return url.replace('preview', 'thumb');
        });
    };

    // =======================
    // Edit-sensitive fetching
    // =======================

    // This is for holding the current VisitNoteEdit id, if visit note being edited
    _class.addIntProperty("currentEditId");
    _class.prototype.getIdForUrl = function() {
        return this.getId() + (this.getCurrentEditId() ? '-'+this.getCurrentEditId() : '');
    };

    function _getterHelper(getFn, editNewGetter, editPrevGetter, editId) {
        var initial = getFn.call(this);
        var current = initial;
        if (!editId) {
            return current;
        } else {
            var numEdits = this.getEdits().length;
            for(var i=0; i<numEdits; i++) {

                // Want to start from most recent edit backwards
                var edit = this.getEdits()[numEdits-1-i];

                if (edit[editNewGetter]()) {
                    // Walk through and update current
                    current = edit[editNewGetter]();
                }
                if (edit.getId() === editId) {
                    // Once we get to the current editId, stop and return what we have
                    return current;
                }
                if (edit[editPrevGetter]()) {
                    // Otherwise keep moving and update to previous value
                    current = edit[editPrevGetter]();
                }
            }
            // If we don't ever run across the edit, then we should return result of standard getFn call
            return initial;
        }
    }
    var super_getNoteTypeId = _class.prototype.getNoteTypeId;
    _class.prototype.getNoteTypeId = function(editId) {
        return _getterHelper.call(this, super_getNoteTypeId, 'getNewNoteTypeId', 'getPreviousNoteTypeId', editId);
    };
    var super_getDocumentDate = _class.prototype.getDocumentDate;
    _class.prototype.getDocumentDate = function(editId) {
        return _getterHelper.call(this, super_getDocumentDate, 'getNewNoteTime', 'getPreviousNoteTime', editId);
    };
    var super_getBmi = _class.prototype.getBmi;
    _class.prototype.getBmi = function(editId) {
        return _getterHelper.call(this, super_getBmi, 'getNewBmi', 'getPreviousBmi', editId);
    };
    var super_getPreviousWeight = _class.prototype.getPreviousWeight;
    _class.prototype.getPreviousWeight = function(editId) {
        return _getterHelper.call(this, super_getPreviousWeight, 'getNewPrevWeight', 'getPreviousPrevWeight', editId);
    };
    var super_getPreviousBmi = _class.prototype.getPreviousBmi;
    _class.prototype.getPreviousBmi = function(editId) {
        return _getterHelper.call(this, super_getPreviousBmi, 'getNewPrevBmi', 'getPreviousPrevBmi', editId);
    };
    var super_getPreviousTime = _class.prototype.getPreviousTime;
    _class.prototype.getPreviousTime = function(editId) {
        return _getterHelper.call(this, super_getPreviousTime, 'getNewPrevTime', 'getPreviousPrevTime', editId);
    };

    // Helpful helper function
    _class.prototype.getEditsOrdering = function() {
        var ordering = {};
        for (var i=0; i<this.getEdits().length; i++) {
            ordering[this.getEdits()[i].getId()] = i;
        }
        return ordering;
    };
    _class.prototype.getEditById = function(editId) {
        for (var i=0; i<this.getEdits().length; i++) {
            if (this.getEdits()[i].getId() === editId) {
                return this.getEdits()[i];
            }
        }
    };

    // ========================================================
    // Methods related to fetching and saving note-related data
    // ========================================================
    _class.prototype.getSingletonVital = function(name, editId) {
        var vitalsSets = this.getVitalsSets()[name];
        if (!vitalsSets) { return; }
        if (vitalsSets.all(true).length) {
            if (!editId && vitalsSets.all().length > 1) {
                UIM && UIM.logError('multiple vitals: '+this.getId()+' '+name);
            }
            // get the latest vital by ID (the default sort is ascending by ID so we want the last item)
            return _.last(vitalsSets.sorted(editId)) || null;
        }
        return null;
    };

    _class.prototype.hasVitals = function() {
        var vitalsSets = this.getVitalsSets();
        for (var vital in vitalsSets) {
            if (vitalsSets[vital].all().length > 0) {
                return true;
            }
        }
        return false;
    };

    // Gets the appropriate checklist for type, editId
    _class.prototype.getChecklists = function(type, editId) {
        var results = {};
        var checklistSet = this.getChecklistSets()[type];
        // Expect only ONE checklist per edit for now
        if (checklistSet.all(true).length) {
            if (!editId && checklistSet.all().length > 1) {
                UIM && UIM.logError('multiple checklists: ' + this.getId() + ' ' + type);
            }
            if (!editId) {
                results.current = checklistSet.sorted()[0];
            } else {
                var latest = checklistSet.sorted(editId)[0];
                if (latest) {
                    if (latest.getReplacedByEditId() === editId) {
                        // In this case, we deleted a checklist most recently!
                        results.current = null;
                        results.replaced = latest;
                    } else {
                        results.current = latest;
                        var currEditId = results.current.getEditId();
                        if (currEditId) {
                            results.replaced = checklistSet.getByReplacedByEditId(currEditId);
                        }
                    }
                }
            }
        }
        return results;
    };

    // Get all the reportIds referenced in this visit note
    _class.prototype.getReferencedReportIds = function() {
        var reportIds = []; // the list to be returned

        /* Internal re-use functions */
        var pushReport = function(id) {
            // the same report may be referenced multiple times but we don't want the duplicates
            if (reportIds.indexOf(id) === -1) { reportIds.push(id); }
        };
        var addIfReportBullet = function(bullet) {
            if (bullet && bullet.getDocumentId() &&
                el8.model.idToModelClass(bullet.getDocumentId()) === 'Report') {
                    pushReport(bullet.getDocumentId());
            }
        };
        /* * */

        /* Go through all of the visit note's bullets and see if any have a getDocumentId() associated */
        var bulletSets = _.values(this.getBulletSets());
        bulletSets.forEach(function(bulletSet) {
            bulletSet.all().forEach(function(bullet) {
                addIfReportBullet(bullet);
                var children = bullet.getChildrenSet().all();
                children.forEach(addIfReportBullet);
            });
        });

        return reportIds;
    };

    _class.prototype.getBulletById = function(bulletId) {
        var bulletSets = _.values(this.getBulletSets());
        var bulletSet = bulletSets.find(function(aBulletSet) {
            return Boolean(aBulletSet.getById(bulletId))
        });

        return bulletSet ? bulletSet.getById(bulletId) : null;
    };

    _class.prototype.addBullet = function(category, spec) {
        spec = spec || {};
        var set = this.getBulletSets()[category];
        if (set) {
            var doc = spec.documentId ?
                el8.ptdata.fetch({ fetchIds: spec.documentId, patientId: this.getPatientId() }) : null;
            var bullet = set.create({
                'text': (spec.text || ''),

                /* All the document reference related fields */
                'documentId': (spec.documentId || null),
                'documentOwnedBy': false,
                'documentSummary': doc ? doc.getNoteSummary() : null,
                'documentSummaryFormatting': null, // no formatting for ref'd docs

                /* Other reference types */
                'patientItemId': (spec.patientItemId || null),
                'labResultId': (spec.labResultId || null),
                'handoutId': (spec.handoutId || null),
                'imoIds': (spec.imoIds || null)
            });
            return bullet;
        }
    };

    _class.prototype.addBulletChild = function(bullet, spec) {
        spec = spec || {};
        var set = bullet.getChildrenSet();
        if (set) {
            var doc = spec.documentId ?
                el8.ptdata.fetch({ fetchIds: spec.documentId, patientId: this.getPatientId() }) : null;
            var child = set.create({
                'parentId': bullet.getId(),
                'text': (spec.text || ''),

                /* All the document reference related fields */
                'documentId': (spec.documentId || null),
                'documentOwnedBy': false,
                'documentSummary': doc ? doc.getNoteSummary() : null,
                'documentSummaryFormatting': null, // no formatting for ref'd docs

                /* Other reference types */
                'patientItemId': (spec.patientItemId || null),
                'labResultId': (spec.labResultId || null),
                'handoutId': (spec.handoutId || null)
            });
            return child;
        }
    };

    _class.prototype.addReferencedBullet = function(docId, labResultId) { //successCb) {

        // Associated documents always go into "Referenced" Category
        var set = this.getBulletSets()['Referenced'];
        if (set) {
            // Enforce here at model level that we never duplicate referenced documents
            // Just used as a last-ditch effort though, since it only looks at bullets that
            // are already added to the set (not those in the middle of being saved)
            if (set.getByReferencedDocId(docId)) { return null; }

            var doc = el8.ptdata.fetch({ fetchIds: docId, patientId: this.getPatientId() });
            var bullet = set.create({
                'text': '', // empty str for referenced documents
                'documentId': docId,
                'documentOwnedBy': false,
                'documentSummary': doc.getNoteSummary(),
                'documentSummaryFormatting': null, // no formatting for ref'd docs
                'labResultId': labResultId
            });
            return bullet;
        }

        return null;
    };

    _class.prototype.associateItem = function(itemId, successCb) {
        // Associates item directly to the visit note
        $.el8_ajax({
            type: 'POST',
            url: el8Globals['PATIENT_PATH']+'visit-notes/'+this.getIdForUrl()+'/referenced_items/'+itemId+'/',
            success: successCb
        });
    };

    _class.prototype.addOwnedDocumentBullet = function(doc, category) {
        if (!doc) { return; }

        var set = this.getBulletSets()[category];
        var data = doc.getNoteOwnedDocSummary(true);
        var patientData = doc.getPatientSummary();
        if (typeof(patientData) === "string") {
            patientData = {
                'summary': patientData,
                'summary_formatting': null
            };
        }
        if (set) {
            var bullet = set.create({
                'text': '', // empty str for referenced documents
                'documentId': doc.getId(),
                'documentOwnedBy': true,
                'documentSummary': data['summary'],
                'documentSummaryFormatting': data['summary_formatting'],
                'patientSummary': patientData['summary'],
                'patientSummaryFormatting': patientData['summary_formatting']
            });
            return bullet;
        }

        return null;
    };

    _class.prototype.sign = function(callbackFn) {
        this.setOnHold(false);
        el8.appservice.notifier.notify( this.getNotifyText('SAVE_IN_PROGRESS') );
        var that = this;

        $.el8_ajax({
            url: el8Globals['PATIENT_PATH'] + 'visit-notes/' + that.getIdForUrl() +'/sign/',
            type: 'POST',
            success: function(data) {
                if (that.isPreview()) {
                    that.setPreview(false);
                    el8.appchart.mainFeeds.chart.removePreview(that.getId());
                }
                that.populate(data);
                if (!that.getCurrentEditId()) {
                    el8.ptdata.visitNotes.addOrUpdate(that);
                } else {
                    that.setCurrentEditId(null);
                    el8.ptdata.visitNotes.addOrUpdate(that);
                    el8.ptdata.tempVisitNotes.remove(that.getId()); /* the tempVisitNote needs to be removed */

                     // it is very stupid that this file knows anything about letters selectAttachments
                     // TODO: fix this by making visitNoteEdits trigger normal notifiers
                    el8.appchart.letters.selectAttachments.ensureFeedRefresh('popular');
                    el8.appchart.letters.selectAttachments.ensureFeedRefresh('visitnotes');
                }
                el8.appservice.notifier.notify( that.getNotifyText('SAVE_COMPLETE'));
                if (callbackFn) { callbackFn(); }
            }
        });
    };

    _class.prototype.saveDocumentDate = function(aDate, callbackFn) {
        if (aDate) {
            this.setDocumentDate(el8.service.tz.newTzDateTime(aDate));
        }
        if (this.getDocumentDate()) {
            var docDate = this.getDocumentDate();
            var r = {'document_date': el8.service.tz.asServerFormatDateTime(docDate)};
            var that = this;
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+this.getIdForUrl()+'/time/',
                data: {data: JSON.stringify(r)},
                success: function(data) {
                    // Once we have manually updated documentDate, we should be guaranteed
                    // that displayDate and documentDate are the same
                    that.setDisplayDate(docDate);
                    if (callbackFn) { callbackFn(data); }
                }
            });
        }
    };

    _class.prototype.saveType = function(typeId) {
        if (typeId) { this.setNoteTypeId(typeId); }
        if (this.getNoteTypeId()) {
            var d = {'type': this.getNoteTypeId()};
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+this.getIdForUrl()+'/type/',
                data: {'data': JSON.stringify(d)}
            });
        }
    };

    _class.prototype.savePhysician = function(physicianId) {
        if (!physicianId) { return; }
        this.setPhysicianId(physicianId);
        var d = { 'physician_id': this.getPhysicianId() };
        $.el8_ajax({
            type: 'POST',
            url: el8Globals['PATIENT_PATH']+'visit-notes/'+this.getId()+'/physician/',
            data: JSON.stringify(d)
        });
    };

    // Saving the template type
    _class.prototype.saveTemplate = function(template) {
        if (template) { this.setTemplate(template); }
        if (this.getTemplate()) {
            var d = {'template': this.getTemplate()};
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+this.getId()+'/template/',
                data: {'data': JSON.stringify(d)}
            });
        }
    };

    _class.prototype.saveChecklistItems = function(type, list, opts) {
        // Expect "list" to be an array of objects that have three keys:
        //    name, value, sequence
        opts = opts || {};
        // NOTE: The note itself doesn't keep track of all these checklist items
        // as they get saved; relies on the whole encode_json() rebuild upon sign off
        if (type && list) {
            var data = (list instanceof Array) ? {'items': list} : list;
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'visit-notes/'+this.getIdForUrl()+'/checklist/'+type+'/',
                data: {'data': JSON.stringify(data)},
                success: function() {
                    if (opts.successCb) { opts.successCb(); }
                },
                async: opts.async,
                // Over-ride regular error behavior because we are expecting
                // the visit note lastDitchSave() to rescue everything
                error_override: function() {
                    if (opts.errorCb) { opts.errorCb(); }
                }
            });
        }
    };
    _class.prototype.saveChecklistItem = function(type, item, opts) {
        return this.saveChecklistItems(type, item, opts);
    };

    // ==================================================
    // All methods related to updating Bill on visit note
    // ==================================================
    _class.prototype.setBillFromSpec = function(spec) {
        if (this.getBill()) {
            this.getBill().populate(spec);
        } else {
            var bill = el8.ptdata.model.note.bill(spec);
            this.setBill(bill);
        }
        el8.ptdata.visitNotes.trigger(EVENTS.UPDATED, this);
    };

    // if opts.forceSave is true, then we will save the bill regardless if it's empty
    // used for VNT when we need a blank bill to be prepopulated before we can export CPT
    // from the VNT
    _class.prototype.saveEntireBill = function(opts) {
        opts = opts || {};
        if (this.getBill() &&
            (opts.forceSave || this.getBill().getId() || !this.getBill().isEmpty())) {
            var async;
            if (opts.async === undefined) {
                // If have a bill ID, do async; else do sync
                async = Boolean(this.getBill().getId());
            } else {
                async = opts.async;
            }
            var that = this;
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('saveBill', [this.getPatientId(), this.getId()]),
                data: JSON.stringify(this.getBill().asMap(true, false)),
                async: async,
                success: function(data) {
                    that.getBill().populate(data);
                    if (opts.successCb) { opts.successCb(that.getBill()); }
                    el8.ptdata.visitNotes.trigger(EVENTS.UPDATED, that);
                },
                error: function(err) {
                    if (opts.errorCb) { opts.errorCb(err); }
                }
            });
        }
    };
    _class.prototype.fetchBill = function(opts) {
        var that = this;
        opts = opts || {};
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('fetchBill', [this.getId()]),
            async: opts.async,
            success: function(data) {
                that.setBillFromSpec(data);
                if (opts.successCb) { opts.successCb(); }
            },
            error: opts.errorCb
        });
    };
    _class.prototype.dismissBill = function(opts) {
        var that = this;
        opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('dismissBill', [this.getPatientId(), this.getId()]),
            async: opts.async,
            success: function(data) {
                that.setBillFromSpec(data);
                if (opts.successCb) { opts.successCb(); }
            },
            error: opts.errorCb
        });
    };
    _class.prototype.sendBillEarly = function(opts) {
        var that = this;
        opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('sendBillEarly', [this.getPatientId(), this.getId()]),
            async: opts.async,
            success: function(data) {
                that.setBillFromSpec(data);
                if (opts.successCb) { opts.successCb(); }
            },
            error: opts.errorCb
        });
    };
    _class.prototype.deferBill = function(opts) {
        var that = this;
        opts = opts || {};
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('deferBill', [this.getPatientId(), this.getId()]),
            async: opts.async,
            success: function(data) {
                that.setBillFromSpec(data);
                if (opts.successCb) { opts.successCb(); }
            },
            error: opts.errorCb
        });
    };


    // ===================================
    // Basic descriptor methods
    // ====================================
    _class.prototype.getDescription = function(noteTypeId) {
        noteTypeId = noteTypeId || this.getNoteTypeId();
        var noteType = el8.data.visitNoteTypes.getByIdIncludingDeleted(noteTypeId);
        // We never expect to not have a noteType, but a timing issue on load might cause this
        // Gonna watch for and put a conditional to avoid type errors
        if (!noteType) { UIM && UIM.logError('null noteType in visit note getDescription()'); }

        if (this.isImportedNote()) {
            return el8.template.ptdata.model.note.importedVisitDescription({
                type: noteType ? noteType.asSoyMap() : '',
                physicianFullName: this.getPhysicianFullName(),
                documentDate: el8.service.tz.soyStr(this.getDocumentDate())
            }).el8_unescape();

        } else {
            return el8.template.ptdata.model.note.visitNoteDescription({
                signDate: this.getSignDate(),
                type: noteType ? noteType.asSoyMap() : ''
            }).el8_unescape();
        }
    };

    /* There is an equivalent template function designed to work with the visit note's JSON
     * at ptdata.model.note.visitNoteHeaderSummary. If you make changes here, make them there
     * too (sorry for the code duplication...) */
    _class.prototype.getHeaderSummary = function() {
        var str = '';
        if (this.getBulletSets()['Reason'].asSingleField()) {
            str += ('cc: ' + this.getBulletSets()['Reason'].asSingleField() + '. ');
        }
        this.getBulletSets()['Problem'].sorted().map(
            function(p, index) {
                str += ((index+1) + '. ' + p.getText() + ' ');
            }
        );
        return str.trim(); // trim off extra spaces at end
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.note.visitNoteSummary({
            documentDate: el8.service.tz.soyStr(this.getDocumentDate())
        }).el8_unescape();
    };
    _class.prototype.getNotifyText = function( type ) {
        if( type === 'SAVE_IN_PROGRESS' ) {
            if( this.isOnHold() ) {
                return 'Placing note on hold...';
            } else {
                return 'Saving note...';
            }
        } else if( type === 'SAVE_COMPLETE' ) {
            if( this.isOnHold() ) {
                return 'Visit note placed on hold.';
            } else {
                return 'Visit note filed in chart.';
            }
        } else if( type === 'SAVE_DRAFT' ) {
            return 'Visit note draft saved.';
        } else if( type === 'SAVE_PREVIEW' ) {
            return 'See preview of visit note in chart...';
        } else if( type === 'DELETE_IN_PROGRESS' ) {
            return 'Discarding note...';
        } else if( type === 'DELETE_COMPLETE' ) {
            return 'Visit note discarded.';
        } else if( type === 'DELETE_COMPLETE_IMAGES_REFILED' ) {
            return 'Visit note discarded. Attached images moved to Unfiled Images in the Fax Inbox.';
        } else if( type === 'ADD_TO_NOTE' ) {
            return 'Visit note added to current note.';
        }
    };

    // OVERRIDE standard getFeedItemId of el8_Entity to accommodate preview
    _class.prototype.getFeedItemId = function() {
        return (this.isPreview() ? 'preview_' : '') +
            'feedItem_'+this.getModelClass()+'_'+this.getId();
    };

    _class.prototype.getPhysicianFullName = function() {
        if (!this.getPhysicianId()) { return ''; }
        var physician = el8.data.referencedPracticians.getById(this.getPhysicianId());
        return (physician) ? physician.getFullName() : '';
    };


    // ===================================
    // Print visit note derived printouts
    // ====================================
    _class.prototype.printNote = function(withBill, withMu) {
        var printPath = el8.service.urls.get('printVisitNote', [this.getIdForUrl(), withBill, withMu]);
        if (el8Globals.APP === 'chart') {
            el8.appchart.printService.open({
                url: printPath,
                attachmentId: this.getId()
            });
        } else {
            window.open(printPath);
        }
    };
    _class.prototype.printPatientSummary = function() {
        var printPath = el8.service.urls.get('printPatientSummary', [this.getId()]);
        window.open(printPath);
    };
    _class.prototype._printPatientInvoice = function(printoutType) {
        var detailedVersion, icd9Only, icd10Only;

        if (printoutType === 'simple') {
            detailedVersion = false;
        } else if (printoutType === 'icd9') {
            detailedVersion = true;
            icd9Only = true;
        } else if (printoutType === 'icd10') {
            detailedVersion = true;
            icd10Only = true;
        }

        var printPath = el8.service.urls.get('printPatientInvoice',
                                             [this.getPatientId(), this.getId(), detailedVersion, icd10Only, icd9Only]);
        window.open(printPath);
    };
    _class.prototype.printSimplePatientInvoice = function() {
        this._printPatientInvoice('simple');
    };
    _class.prototype.printIcd9PatientInvoice = function() {
        this._printPatientInvoice('icd9');
    };
    _class.prototype.printIcd10PatientInvoice = function() {
        this._printPatientInvoice('icd10');
    };
    _class.prototype.printClinicalSummary = function() {
        this.updateMeaningfulUseInfo({'note_summary_provided': true});
        var printPath = el8.service.urls.get('printClinicalSummary', [this.getId(), true]);
        window.open(printPath);
    };

    // ===================================
    // Meaningful use info related methods
    // ====================================
    el8.ptdata.model.note.addMuInfoMethods(_class);
    _class.prototype.updateMeaningfulUseInfo = function(_data) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('visitNoteMeaningfulUse', [this.getId()]),
            data: {data: JSON.stringify(_data)},
            success: function(resp) {
                that.setMeaningfulUseInfoFromSpec(resp);
            }
        });
    };
    _class.prototype.hasPrintableMeaningfulUse = function() {
        return this.getMeaningfulUseInfo() &&
            this.getMeaningfulUseInfo().getTransitionOfCare();
    };

    // ===================================
    // Amendment request related methods
    // ====================================
    _class.prototype.saveAmendmentRequest = function(spec) {
        var that = this;
        spec = spec || {};
        var successCb = spec.successCb || null;
        var amendmentRequest = spec.amendmentRequest;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('visitNoteAmendmentRequest', [this.getId()]),
            data: {data: JSON.stringify(amendmentRequest.asMap(true))},
            success: function(data) {
                that.setAmendmentRequestFromSpec(data);
                if (successCb) { successCb(that.getAmendmentRequest()); }
            }
        });
    };
    _class.prototype.setAmendmentRequestFromSpec = function(spec) {
        if (this.getAmendmentRequest()) {
            this.getAmendmentRequest().populate(spec);
        } else {
            var amendmentRequest = el8.ptdata.model.amendmentRequest(spec);
            this.setAmendmentRequest(amendmentRequest);
        }
    };

    el8.ptdata.model.note.visit = function(spec) {
        spec.model_class = 'VisitNote';
        return new _class(spec);
    };
})();
